import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <p>Built by Corinne Pradier with React - 2021</p>
      <p>
        Design is inspired by{" "}
        <a href="https://brittanychiang.com/" target="_blank" rel="noreferrer">
          Brittany Chiang's portfolio
        </a>
        .
      </p>
    </div>
  );
};

export default Footer;
